import { Component } from '@angular/core';
import { NavController, ModalController, AlertController, Platform, NavParams } from 'ionic-angular';
import { ModalPushPage } from '../../pages/modal-push/modal-push';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { CalendarModalOptions } from 'ion2-calendar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as XLSX from '../../xlsx';
import { Storage } from '@ionic/storage';
import { File } from '@ionic-native/file';
import { MapasPage } from '../../pages/mapas/mapas';
import { HTTP } from '@ionic-native/http';
import { ListPage } from '../../pages/list/list';
import { HorasUtil } from '../../providers/horas/horas';
import { AhoritaAprendizaje, CasoAprendizajeIA, ContextoJornadaIA } from '../../providers/ahorita-aprendizaje';

@Component({
  selector: 'page-picajes',
  templateUrl: 'picajes.html',
})
export class PicajesPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  misapp: Array<{ title: string, descripcion: string, imagen: string, component: any }>;

  resultado;
  type: 'string';
  minuto = [];
  minH = [];
  color = [];
  cabecera = [];
  picajes;
  valo = '654321123456';
  formulario = { imagen1: '', sentido1: '', hora1: '', localizacion1: '', obra1: '', tipo1: '' };
  FROM = '';
  rs_picajes;
  rs_xls;
  valorleft;
  horaactual;
  incidencias;

  callback: any = null;
  codigotrabajador: any = '';
  nombretrabajador: any = '';
  diaParam: any = '';
  revisionAhoritaIA = false;
  incidenciaAprendizajeIA: any = null;
  private snapshotInicialAhoritaIA: any[] = [];
  correccionValidadaIA = false;
  aprendizajeGuardadoIA = false;
  analizandoCorreccionIA = false;
  propuestaAprendizajeIA: CasoAprendizajeIA | null = null;
  ayudasEstudioIA: any[] = [];
  conclusionEstudioIA = '';

  optionsRange: CalendarModalOptions = {
    color: 'dark',
    weekStart: 1,
    weekdays: ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'],
    canBackwardsSelected: true,
    cssClass: 'my-day',
    daysConfig: []
  };

  constructor(
    public http2: HTTP,
    private storage: Storage,
    private alertCtrl: AlertController,
    private platform: Platform,
    public fb: FormBuilder,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public funciones: FuncionesProvider,
    public variables: VariablesProvider,
    public file: File
  ) {
    this.valorleft = 10;

    if (this.variables.CONTROLACCESO >= 10) {
      // this.valorleft = 100;
    }

    this.variables.btatras = true;

    this.callback = this.navParams.get('callback');
    this.codigotrabajador = this.navParams.get('codigotrabajador') || this.variables.CODIGOTRABAJADOR;
    this.nombretrabajador = this.navParams.get('nombretrabajador') || '';
    this.diaParam = this.navParams.get('DIA') || this.variables.DIA;
    this.revisionAhoritaIA = this.navParams.get('aprendizajeIA') === true;
    this.incidenciaAprendizajeIA = this.navParams.get('incidenciaIA') || null;

    if (this.codigotrabajador) {
      this.variables.CODIGOTRABAJADOR = this.codigotrabajador;
    }

    if (this.diaParam) {
      this.variables.DIA = this.diaParam;
      this.FROM = this.diaParam;
    } else {
      const f = new Date();
      this.FROM = f.getFullYear() + '-' + ('0' + (f.getMonth() + 1)).slice(-2) + '-' + ('0' + f.getDate()).slice(-2);
      this.variables.DIA = this.FROM;
    }

    this.obtieneincidencias();

    const date = new Date();
    const minutes = date.getMinutes();
    const hours = date.getHours();

    this.myForm = this.fb.group({
      imagen: [''],
      sentido: [''],
      hora: ['', [Validators.required, HorasUtil.validador]],
      localizacion: [''],
      obra: ['', [Validators.required]],
      tipo: ['', [Validators.required]]
    });

    this.myForm1 = this.fb.group({
      imagen1: [''],
      sentido1: [''],
      hora1: [''],
      localizacion1: [''],
      obra1: [''],
      tipo1: ['']
    });

    this.horaactual =
      ((hours < 10) ? ('0' + hours) : hours) +
      ':' +
      ((minutes < 10) ? ('0' + minutes) : minutes);

    this.optionsRange.daysConfig = this.variables._daysConfig || [];
    this.obtenerpicajes();
  }

  private volverConRefresco(): void {
    if (this.callback) {
      this.callback({ actualizado: true }).then(() => {
        this.navCtrl.pop();
      });
    } else {
      this.navCtrl.pop();
    }
  }

  borrar(id) {
    let alert = this.alertCtrl.create({
      title: 'Borrar',
      message: '¿Confirma borrar la linea?',
      cssClass: 'alertCustomCss',
      buttons: [
        {
          text: 'No',
          role: 'No',
          handler: () => { }
        },
        {
          text: 'Si',
          handler: () => {
            this.funciones.delpicada(id).then(data => {
              this.obtenerpicajes();
              //this.volverConRefresco();
            }).catch(error => {
              console.log(error);
            });
          }
        }
      ]
    });

    alert.present();
  }

  validar(id) {
    let alert = this.alertCtrl.create({
      title: 'Validar',
      message: '¿Valida la picada del trabajador?',
      cssClass: 'alertCustomCss',
      buttons: [
        {
          text: 'No',
          role: 'No',
          handler: () => { }
        },
        {
          text: 'Si',
          handler: () => {
            this.funciones.editapicaje('Incidencia Aceptada', id).then(data => {
              this.obtenerpicajes();
              //this.volverConRefresco();
            }).catch(error => {
              console.log(error);
            });
          }
        }
      ]
    });

    alert.present();
  }

  resolverIncidencia(id) {
    let alert = this.alertCtrl.create({
      title: 'Validar',
      message: '¿Se resolvió la incidencia?',
      cssClass: 'alertCustomCss',
      buttons: [
        {
          text: 'No',
          role: 'No',
          handler: () => { }
        },
        {
          text: 'Si',
          handler: () => {
            this.funciones.editapicaje('Resuelto', id).then(data => {
              this.obtenerpicajes();
              //this.volverConRefresco();
            }).catch(error => {
              console.log(error);
            });
          }
        }
      ]
    });

    alert.present();
  }

  cambiasentido(valor, id) {
    let alert = this.alertCtrl.create({
      title: 'Cambio de sentido',
      message: '¿Desea cambiar el sentido de la picada?',
      cssClass: 'alertCustomCss',
      buttons: [
        {
          text: 'No',
          role: 'No',
          handler: () => { }
        },
        {
          text: 'Si',
          handler: () => {
            this.funciones.editapicajesentido(valor, id).then(data => {
              this.obtenerpicajes();
              //this.volverConRefresco();
            }).catch(error => {
              console.log(error);
            });
          }
        }
      ]
    });

    alert.present();
  }

  openmapa(filtro, id) {
    this.variables.usuariomapa = filtro;
    this.variables.usuariomapaid = id;
    this.navCtrl.push(MapasPage);
  }

  formatearLocalizacion(localizacion: string): string {
    if (!localizacion) {
      return '';
    }

    var lug = localizacion.indexOf('-');
    var lat;
    var lng;

    if (lug <= 0) {
      lug = localizacion.indexOf('.');
      if (lug > 0) {
        var stri = localizacion.substr(lug + 1);
        lug = lug + stri.indexOf('.');
      }
    }

    if (lug > 0) {
      lat = localizacion.substr(0, lug).slice(0, 8) + '...';
      lng = localizacion.substr(lug).slice(0, 8) + '...';
    } else {
      lat = localizacion;
      lng = '';
    }

    return `${lat}, ${lng}`;
  }

  pintargrafica2() {
    var sum = 0;
    var horas = 0;

    this.cabecera[0] = 's';

    for (let x = 0; x < 144; x++) {
      sum = sum + 1;
      this.minuto[x - 2] = x.toString();
      this.color[x - 2] = 'rojo';

      if (sum == 6) {
        this.cabecera[horas] = horas;
        horas = horas + 1;
        sum = 0;
      }

      if (x > 114) {
        this.color[x] = 'rojo';
      }
    }
  }

  vertodo() {
    this.variables.imprimir = true;
  }

  async obtieneincidencias() {
    this.funciones.obtieneincidenciasdelmes('mes').then((data) => {
      this.incidencias = data;
      this.variables._daysConfig = this.variables._daysConfig || [];

      this.incidencias.forEach((incidencia) => {
        this.variables._daysConfig.push({
          date: new Date(incidencia.FECHA),
          subTitle: '⚠️',
          cssClass: 'incidencia-day'
        });
      });

      this.optionsRange = {
        ...this.optionsRange,
        daysConfig: this.variables._daysConfig
      };
    }).catch((error) => {
      console.log(error);
    });
  }

  onChange($event) {
    this.FROM = $event;
    this.variables._daysConfig = [];

    this.variables._daysConfig.push({
      date: new Date($event),
      cssClass: 'my-day'
    });

    this.variables.DIA = $event;
    this.storage.set('DIASELECIONADO', this.variables.DIA);

    this.obtenerpicajes();
  }

  async existe(url: string): Promise<boolean> {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch (error) {
      throw error;
    }
  }

  obtenerpicajes() {
    var lug;
    var Local;

    if (!this.FROM) {
      var f = new Date();
      this.FROM = f.getFullYear() + '-' + ('0' + (f.getMonth() + 1)).slice(-2) + '-' + ('0' + f.getDate()).slice(-2);
    }

    this.rs_picajes = [];

    // La consulta ampliada se usa solo dentro de la pantalla de picadas. De este
    // modo se muestran los estudios guardados aunque se acceda desde "Ver picadas",
    // sin añadir peso ni peticiones nuevas a la carga del listado general.
    const cargarPicadas = this.funciones.obtienepicajesdescestudio(
      this.variables.CODIGOTRABAJADOR,
      this.FROM
    );

    cargarPicadas.then(
      data => {
        this.rs_picajes = Array.isArray(data) ? data : [];
        this.rs_xls = [];

        for (var _i = 0; _i < this.rs_picajes.length; _i++) {
          this.rs_picajes[_i].IMAGEN = 'assets/imgs/avatar.svg';

          if (this.rs_picajes[_i].LOCALIZACION) {
            lug = this.rs_picajes[_i].LOCALIZACION.indexOf('-');
            if (lug > 0) {
              Local = this.rs_picajes[_i].LOCALIZACION.substr(0, lug) + ',' + this.rs_picajes[_i].LOCALIZACION.substr(lug);
              this.rs_picajes[_i].LOCALIZACION2 = 'https://www.google.es/maps/@' + Local + ',18z';
            } else {
              this.rs_picajes[_i].LOCALIZACION2 = '';
            }
          } else {
            this.rs_picajes[_i].LOCALIZACION2 = '';
          }
        }

        this.actualizarAyudasEstudioIA();

        for (var j = 0; j < this.rs_picajes.length; j++) {
          this.rs_xls.push({
            SENTIDO: '' + this.rs_picajes[j].SENTIDO,
            HORA: '' + this.rs_picajes[j].HORA,
            LOCALIZACION: '' + this.rs_picajes[j].LOCALIZACION,
            OBRA: '' + this.rs_picajes[j].OBRA,
            TIPO: '' + this.rs_picajes[j].TIPO
          });
        }
      }
    ).catch(error => {
      this.ayudasEstudioIA = [];
      this.conclusionEstudioIA = '';
      console.log(error);
    });
  }

  tieneFiabilidadIA(picada: any): boolean {
    if (!picada) { return false; }
    const valor = picada.FIABILIDAD !== undefined ? picada.FIABILIDAD : picada.fiabilidad;
    return valor !== null && valor !== undefined && String(valor).trim() !== '' && isFinite(Number(valor));
  }

  obtenerFiabilidadIA(picada: any): number | null {
    if (!this.tieneFiabilidadIA(picada)) { return null; }
    const valor = picada.FIABILIDAD !== undefined ? picada.FIABILIDAD : picada.fiabilidad;
    return Math.max(0, Math.min(100, Math.round(Number(valor))));
  }

  obtenerEstudioIA(picada: any): string {
    if (!picada) { return ''; }
    const valor = picada.ESTUDIO_IA !== undefined ? picada.ESTUDIO_IA : picada.estudio_ia;
    return valor === null || valor === undefined ? '' : String(valor).trim();
  }

  private actualizarAyudasEstudioIA(): void {
    const evaluadas = (Array.isArray(this.rs_picajes) ? this.rs_picajes : []).map((picada: any, indice: number) => ({
      indice: indice + 1,
      hora: String(picada && picada.HORA || '').substr(0, 5),
      sentido: String(picada && picada.SENTIDO || '').toUpperCase(),
      fiabilidad: this.obtenerFiabilidadIA(picada),
      estudio: this.obtenerEstudioIA(picada)
    })).filter((item: any) => item.fiabilidad !== null || !!item.estudio);

    evaluadas.sort((a: any, b: any) => {
      const valorA = a.fiabilidad === null ? 101 : a.fiabilidad;
      const valorB = b.fiabilidad === null ? 101 : b.fiabilidad;
      return valorA - valorB || a.indice - b.indice;
    });

    this.ayudasEstudioIA = evaluadas;
    this.conclusionEstudioIA = this.construirConclusionEstudioIA(evaluadas);
  }

  private construirConclusionEstudioIA(evaluadas: any[]): string {
    if (!evaluadas.length) { return ''; }

    const principal = evaluadas[0];
    const texto = String(principal.estudio || '').toLowerCase();
    const sentido = principal.sentido === 'ENT' ? 'entrada' :
      (principal.sentido === 'SAL' ? 'salida' : 'picada');
    const referencia = 'la ' + sentido + ' de las ' + (principal.hora || '--:--');
    let motivo = 'Es la que menos encaja con el conjunto de la jornada y el historial del trabajador.';

    if (/duplicad|repetid|dos sentidos iguales|mismo sentido/.test(texto)) {
      motivo = 'La secuencia parece repetida; comprueba si sobra o si tiene el sentido equivocado.';
    } else if (/intervalo muy breve|0 min|1 min|un minuto/.test(texto)) {
      motivo = 'Está demasiado próxima a otra picada; comprueba si ambas corresponden a acciones reales.';
    } else if (/sentido incorrecto|cambiar.*sentido|invertir.*sentido/.test(texto)) {
      motivo = 'Su sentido no encaja bien con la secuencia; comprueba si debe cambiarse.';
    } else if (/salida sin entrada|falta.*entrada|entrada.*falta/.test(texto)) {
      motivo = 'Parece faltar una entrada anterior para que la secuencia quede completa.';
    } else if (/cierre pendiente|falta.*salida|salida.*falta|sin cierre/.test(texto)) {
      motivo = 'Parece faltar una salida para cerrar correctamente la jornada.';
    }

    const secundarias = evaluadas.filter((item: any, indice: number) =>
      indice > 0 && item.fiabilidad !== null && item.fiabilidad < 60
    ).slice(0, 2);
    let adicional = '';
    if (secundarias.length) {
      const referencias = secundarias.map((item: any) => {
        const nombre = item.sentido === 'ENT' ? 'entrada' : (item.sentido === 'SAL' ? 'salida' : 'picada');
        return nombre + ' de las ' + (item.hora || '--:--');
      });
      adicional = ' Revisa también la ' + referencias.join(' y la ') + ' antes de validar.';
    }

    return 'Ahorita sugiere revisar primero ' + referencia + '. ' + motivo + adicional;
  }

  validarCorreccionIA(): void {
    if (!this.revisionAhoritaIA || this.correccionValidadaIA || this.analizandoCorreccionIA) { return; }
    const picadas = Array.isArray(this.rs_picajes) ? this.rs_picajes : [];
    const horasInvalidas = picadas.some((p: any) => HorasUtil.normalizar(p.HORA) === null);
    if (horasInvalidas) {
      this.alertCtrl.create({
        title: 'Hora no valida',
        message: 'Corrige las horas antes de validar la incidencia.',
        buttons: ['Aceptar']
      }).present();
      return;
    }

    this.analizandoCorreccionIA = true;
    const guardar = picadas.map((p: any) => {
      p.HORA = HorasUtil.normalizar(p.HORA);
      return this.funciones.editapicajecompleto(p.ID, p.HORA, p.OBRA);
    });
    Promise.all(guardar).then(() => {
      const incidencia = this.incidenciaAprendizajeIA || {};
      const id = incidencia.ID || incidencia.id || incidencia.IDPICAJE || incidencia.ID_PICAJE;
      return id ? this.funciones.editapicaje('Incidencia Aceptada', id) : Promise.resolve(null);
    }).then(() => {
      this.analizandoCorreccionIA = false;
      this.correccionValidadaIA = true;
      this.obtenerpicajes();
      this.alertCtrl.create({
        title: 'Incidencia validada',
        message: 'Los cambios se han guardado y la incidencia ha quedado validada.',
        buttons: ['Aceptar']
      }).present();
    }).catch(error => {
      this.analizandoCorreccionIA = false;
      console.log(error);
      this.alertCtrl.create({
        title: 'No se pudo validar',
        message: 'No se han podido guardar todas las picadas ni validar la incidencia.',
        buttons: ['Aceptar']
      }).present();
    });
  }

  private aprenderCorreccionIA(): Promise<void> {
    const anterior = this.fechaContiguaIA(this.FROM, -1);
    const siguiente = this.fechaContiguaIA(this.FROM, 1);
    return Promise.all([
      this.funciones.obtienepicajesdesc(this.variables.CODIGOTRABAJADOR, this.FROM),
      this.funciones.obtienepicajesdesc(this.variables.CODIGOTRABAJADOR, anterior).catch(() => []),
      this.funciones.obtienepicajesdesc(this.variables.CODIGOTRABAJADOR, siguiente).catch(() => [])
    ]).then((resultado: any[]) => {
      const data: any = resultado[0];
      this.rs_picajes = Array.isArray(data) ? data : [];
      const contexto: ContextoJornadaIA = {
        ANTERIOR: AhoritaAprendizaje.normalizar(resultado[1]),
        SIGUIENTE: AhoritaAprendizaje.normalizar(resultado[2])
      };
      const caso: CasoAprendizajeIA | null = AhoritaAprendizaje.proponer(
        this.variables.CLIENTES_RAZSOCIAL,
        this.variables.CODIGOTRABAJADOR,
        this.nombretrabajador || this.variables.NOMBRETRABAJADOR,
        this.FROM,
        this.snapshotInicialAhoritaIA,
        this.rs_picajes,
        this.incidenciaAprendizajeIA,
        contexto
      );
      this.analizandoCorreccionIA = false;

      if (!caso) {
        this.alertCtrl.create({
          title: 'Incidencia validada',
          message: 'La incidencia se ha validado, pero no hay diferencias en la jornada completa. Ahorita no ha aprendido nada.',
          buttons: ['Aceptar']
        }).present();
        this.obtenerpicajes();
        return;
      }

      this.propuestaAprendizajeIA = caso;
    });
  }

  private guardarPropuestaAprendizajeIA(caso: CasoAprendizajeIA): void {
      AhoritaAprendizaje.guardarPropuesta(caso);
      this.aprendizajeGuardadoIA = true;
      this.funciones.guardarAprendizajeAhorita(caso).then((respuesta: any) => {
        if (respuesta && respuesta.CONFIANZA != null) {
          (caso as any).CONFIANZA = Number(respuesta.CONFIANZA);
          (caso as any).CONFIRMACIONES = Number(respuesta.CONFIRMACIONES || 1);
        }
        AhoritaAprendizaje.actualizarServidor(this.variables.CLIENTES_RAZSOCIAL, caso.ID, respuesta);
      }).catch(() => { /* La memoria local permite probar antes de publicar la API. */ });

      const origenLocal = this.incidenciaAprendizajeIA && this.incidenciaAprendizajeIA._APRENDIZAJE_ORIGEN_LOCAL_ID;
      const origenServidor = this.incidenciaAprendizajeIA && this.incidenciaAprendizajeIA._APRENDIZAJE_ORIGEN_SERVIDOR_ID;
      if (origenLocal && origenLocal !== caso.ID) {
        AhoritaAprendizaje.registrarResultado(this.variables.CLIENTES_RAZSOCIAL, origenLocal, true);
      }
      if (origenServidor) {
        this.funciones.registrarResultadoAprendizajeAhorita(origenServidor, 'ACIERTO').catch(() => {});
      }

      this.alertCtrl.create({
        title: 'Ahorita ha aprendido',
        message: 'Has aprobado esta regla para este cliente. Ahorita podra buscar casos parecidos, pero no corregira ninguno sin tu confirmacion.',
        buttons: ['Aceptar']
      }).present();
  }

  private mostrarPropuestaAprendizajeIA(caso: CasoAprendizajeIA): void {
    const condiciones = AhoritaAprendizaje.describirRegla(caso)
      .map(texto => '<li>' + this.escaparHtmlIA(texto) + '</li>').join('');
    this.alertCtrl.create({
      title: 'Regla propuesta por Ahorita',
      message: '<p><b>Todavia no se ha aprendido ni guardado.</b></p>' +
        '<p>' + this.escaparHtmlIA(caso.EXPLICACION) + '</p>' +
        '<p><b>Condiciones que se compararan:</b></p><ul>' + condiciones + '</ul>' +
        '<p><b>Seguridad inicial de la regla: 25%</b>. Aumentara solo con confirmaciones y aciertos tuyos.</p>',
      cssClass: 'alertCustomCss ahorita-regla-alerta',
      buttons: [
        { text: 'CERRAR SIN APRENDER', role: 'cancel' },
        { text: 'QUIERO APRENDER ESTA REGLA', handler: () => this.confirmarAprendizajeIA(caso) }
      ]
    }).present();
  }

  private confirmarAprendizajeIA(caso: CasoAprendizajeIA): void {
    this.alertCtrl.create({
      title: 'Confirmar aprendizaje',
      message: 'La regla se guardara solamente para <b>' +
        this.escaparHtmlIA(this.variables.CLIENTES_RAZSOCIAL || 'este cliente') +
        '</b>. ¿Confirmas que Ahorita debe aprenderla?',
      cssClass: 'alertCustomCss',
      buttons: [
        { text: 'NO', role: 'cancel' },
        { text: 'SI, APRENDER', handler: () => this.guardarPropuestaAprendizajeIA(caso) }
      ]
    }).present();
  }

  private fechaContiguaIA(fecha: string, dias: number): string {
    const base = Date.parse(String(fecha || '').substr(0, 10) + 'T00:00:00Z');
    if (!isFinite(base)) { return ''; }
    const valor = new Date(base + dias * 86400000);
    return valor.getUTCFullYear() + '-' + ('0' + (valor.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + valor.getUTCDate()).slice(-2);
  }

  private escaparHtmlIA(valor: any): string {
    return String(valor == null ? '' : valor).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  avatarNoDisponible(evento: any): void {
    if (!evento || !evento.target) { return; }
    evento.target.onerror = null;
    evento.target.src = 'assets/imgs/avatar.svg';
  }

  registro() {
    const horaNormalizada = HorasUtil.normalizar(this.formulario.hora1);
    if (horaNormalizada === null || horaNormalizada === '') {
      this.myForm.controls.hora.setErrors({ horaInvalida: true });
      return;
    }
    this.formulario.hora1 = horaNormalizada;
    this.myForm.controls.hora.setValue(horaNormalizada, { emitEvent: false });
    this.myForm.controls.hora.setErrors(null);

    if (this.formulario.sentido1 == '') {
      this.formulario.sentido1 = 'ENT';
    }

    this.funciones.grabapicada(
      this.variables.CODIGOTRABAJADOR,
      this.FROM,
      this.formulario.sentido1,
      this.formulario.hora1,
      this.formulario.obra1,
      this.formulario.tipo1
    ).then(data => {
      this.resultado = data;
      this.obtenerpicajes();
      //this.volverConRefresco();
    }).catch(error => {
      console.log(error);
    });
  }

  valChange(campo: string, value: string, index: number): void {
    switch (campo) {
      case 'TIPO':
        this.rs_picajes[index].TIPO = value;
        break;
      case 'HORA':
        this.rs_picajes[index].HORA = value;
        break;
      case 'OBRA':
        this.rs_picajes[index].OBRA = value;
        break;
    }
  }

  normalizarHoraFormulario(): void {
    const normalizada = HorasUtil.normalizar(this.formulario.hora1);
    if (normalizada !== null) {
      this.formulario.hora1 = normalizada;
      this.myForm.controls.hora.setValue(normalizada, { emitEvent: false });
      this.myForm.controls.hora.setErrors(null);
    } else {
      this.myForm.controls.hora.setErrors({ horaInvalida: true });
    }
  }

  normalizarHoraPicaje(index: number): void {
    const normalizada = HorasUtil.normalizar(this.rs_picajes[index].HORA);
    if (normalizada !== null) {
      this.rs_picajes[index].HORA = normalizada;
    }
  }

  editarpicajes(index, id) {
    this.funciones.editapicaje(this.rs_picajes[index].TIPO, id).then(data => {
      this.obtenerpicajes();
      //this.volverConRefresco();
    }).catch(error => {
      console.log(error);
    });
  }

  salir() {
    this.volverConRefresco();
  }

  abrirPushModal() {
    const modal = this.modalCtrl.create(ModalPushPage);
    modal.present();
  }

  ponencampo(campo: string, value: string): void {
    switch (campo) {
      case 'SENTIDO':
        this.formulario.sentido1 = value;
        break;
    }
  }

  editarpicajestodos() {
    let horasValidas = true;
    for (let i = 0; i < this.rs_picajes.length; i++) {
      const normalizada = HorasUtil.normalizar(this.rs_picajes[i].HORA);
      if (normalizada === null) {
        horasValidas = false;
      } else {
        this.rs_picajes[i].HORA = normalizada;
      }
    }
    if (!horasValidas) {
      this.alertCtrl.create({
        title: 'Hora no válida',
        message: 'Introduzca las horas con formato HH:MM. Por ejemplo: 09:15.',
        buttons: ['Aceptar']
      }).present();
      return;
    }

    let alert = this.alertCtrl.create({
      title: 'Grabar',
      message: '¿Confirma grabar los registros?',
      cssClass: 'alertCustomCss',
      buttons: [
        {
          text: 'No',
          role: 'No',
          handler: () => { }
        },
        {
          text: 'Si',
          handler: () => {
            let promesas: Promise<any>[] = [];

            for (var _i = 0; _i < this.rs_picajes.length; _i++) {
              promesas.push(
                this.funciones.editapicajecompleto(
                  this.rs_picajes[_i].ID,
                  this.rs_picajes[_i].HORA,
                  this.rs_picajes[_i].OBRA
                )
              );
            }

            Promise.all(promesas).then(() => {
              this.rs_xls = [];

              for (var j = 0; j < this.rs_picajes.length; j++) {
                this.rs_xls.push({
                  SENTIDO: '' + this.rs_picajes[j].SENTIDO,
                  HORA: '' + this.rs_picajes[j].HORA,
                  LOCALIZACION: '' + this.rs_picajes[j].LOCALIZACION,
                  OBRA: '' + this.rs_picajes[j].OBRA,
                  TIPO: '' + this.rs_picajes[j].TIPO
                });
              }

              this.obtenerpicajes();
              //this.volverConRefresco();
            }).catch(error => {
              console.log(error);
            });
          }
        }
      ]
    });

    alert.present();
  }

  read(bstr: string) { }

  write(): XLSX.WorkBook {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rs_xls);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
    return wb;
  }

  async import() { }

  async export() {
    const wb: XLSX.WorkBook = this.write();
    const filename: string = 'picadasdeltrabajado' + this.variables.CODIGOTRABAJADOR + '.xlsx';

    try {
      const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob: Blob = new Blob([wbout], { type: 'application/octet-stream' });

      const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
      const dentry = await this.file.resolveDirectoryUrl(target);
      const url: string = dentry.nativeURL || '';

      await this.file.writeFile(url, filename, blob, { replace: true });
    } catch (e) {
      XLSX.writeFile(wb, filename);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/picajes/picajes.ts